 <template>
  <div class="co2Detail _boxBg_dark_big absolute_center">
    <div class="selfClose_btn" @click="close"></div>
    <div class="_boxTitle">碳排放强度</div>
    <div class="yellowLine"></div>
    <div class="_innerBox">
      <div class="left_part">
        <div class="l_title">
          <div class="leftBox-main">
            全厂 <span class="dinBold">{{ carbonPollutionSum }}</span
            >吨CO₂/吨
          </div>
        </div>
        <div class="l_container">
          <div class="l_chart">
            <div class="l_chart_name">行业对标</div>
            <div class="l_chart_box" ref="chart_l1"></div>
          </div>
          <div class="l_chart">
            <div class="l_chart_name">本年月变化</div>
            <div class="l_chart_box" ref="chart_l2"></div>
          </div>
        </div>
      </div>
      <div class="right_part">
        <div class="r_part">
          <div class="r_part_name">
            {{
              isSpecial && processIdList[0]
                ? processIdList[0].processName
                : "烧结"
            }}
            <span class="dinBold">{{ carbonPollutionProcess[0] ?? 0 }}</span
            >吨CO₂/吨
          </div>
          <div class="r_chart_box_one" ref="chart_r1_1"></div>
          <div class="r_chart_box" ref="chart_r1_2"></div>
        </div>
        <div class="r_part">
          <div class="r_part_name">
            {{
              isSpecial && processIdList[1]
                ? processIdList[1].processName
                : "炼铁"
            }}
            <span class="dinBold">{{ carbonPollutionProcess[1] ?? 0 }}</span
            >吨CO₂/吨
          </div>
          <div class="r_chart_box_one" ref="chart_r2_1"></div>
          <div class="r_chart_box" ref="chart_r2_2"></div>
        </div>
        <div class="r_part">
          <div class="r_part_name">
            {{
              isSpecial && processIdList[2]
                ? processIdList[2].processName
                : "炼钢"
            }}
            <span class="dinBold">{{ carbonPollutionProcess[2] ?? 0 }}</span
            >吨CO₂/吨
          </div>
          <div class="r_chart_box_one" ref="chart_r3_1"></div>
          <div class="r_chart_box" ref="chart_r3_2"></div>
        </div>
        <div
          class="r_part"
          v-if="processIdList.some((i) => i.processName == '焦化')"
        >
          <div class="r_part_name">
            焦化
            <span class="dinBold">{{ carbonPollutionProcess[3] ?? 0 }}</span
            >吨CO₂/吨
          </div>
          <div class="r_chart_box_one" ref="chart_r4_1"></div>
          <div class="r_chart_box" ref="chart_r4_2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { unwarp } from "@/utils/tools.js";
import { mapGetters } from "vuex";
import getOpt1 from "./chartBar1.js";
import getOpt2 from "./chartBar2.js";
export default {
  props: {},
  data() {
    return {
      customerId: this.$store.state.customerId,
      carbonPollutionSum: 0,
      carbonPollutionProcess: [],
      benchmarking: [{}, {}, {}, {}],
      chart_l1: null,
      chart_l2: null,
      chart_r1_1: null,
      chart_r1_2: null,
      chart_r2_1: null,
      chart_r2_2: null,
      chart_r3_1: null,
      chart_r3_2: null,
      chart_r4_1: null,
      chart_r4_2: null,
      timer: null,

      allYearChangeData: { key: [], value: [] },
      processChangeData: [],
      processIdList: [],
      isSpecial: false,
      is89: false,
    };
  },
  watch: {},
  computed: {
    getImg() {
      return (i) => {
        let bg_url;
        if (i && Number(i) < 0) {
          bg_url = require("./img/down.png");
        } else {
          bg_url = require("./img/up.png");
        }
        let url = "url(" + bg_url + ")";
        return {
          backgroundImage: url,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          display: "inline-block",
          width: "10px",
          height: "16px",
        };
      };
    },
    getNum() {
      return (i) => {
        if (i === "--") return "--";
        if (i == 100) return Number(i).toFixed(0);
        else return Number(i).toFixed(2);
      };
    },
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  created() {
    if (this.customerId == 42 || this.customerId == 89) {
      this.isSpecial = true;
    }
    if (this.customerId == 89) {
      this.is89 = true
    }
  },
  mounted() {
    this.getAllData();
  },
  unmounted() {
    if (this.chart_l1) {
      this.chart_l1.dispose();
      this.chart_l1 = null;
    }
    if (this.chart_l2) {
      this.chart_l2.dispose();
      this.chart_l2 = null;
    }
    if (this.chart_r1_1) {
      this.chart_r1_1.dispose();
      this.chart_r1_1 = null;
    }
    if (this.chart_r1_2) {
      this.chart_r1_2.dispose();
      this.chart_r1_2 = null;
    }
    if (this.chart_r2_1) {
      this.chart_r2_1.dispose();
      this.chart_r2_1 = null;
    }
    if (this.chart_r2_2) {
      this.chart_r2_2.dispose();
      this.chart_r2_2 = null;
    }
    if (this.chart_r3_1) {
      this.chart_r3_1.dispose();
      this.chart_r3_1 = null;
    }
    if (this.chart_r3_2) {
      this.chart_r3_2.dispose();
      this.chart_r3_2 = null;
    }
    if (this.chart_r4_1) {
      this.chart_r4_1.dispose();
      this.chart_r4_1 = null;
    }
    if (this.chart_r4_2) {
      this.chart_r4_2.dispose();
      this.chart_r4_2 = null;
    }
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  methods: {
    close() {
      if (this.fromPage) {
        this.$popup[this.fromPage] && this.$popup[this.fromPage]();
      } else {
        let that = this._.appContext.app;
        this.$popup.close(that);
      }
    },
    renderAllChart() {
      this.$nextTick(() => this.renderChart_l1());
      this.$nextTick(() => this.renderChart_l2());
      this.$nextTick(() => this.renderChart_r1_1());
      this.$nextTick(() => this.renderChart_r1_2());
      this.$nextTick(() => this.renderChart_r2_1());
      this.$nextTick(() => this.renderChart_r2_2());
      this.$nextTick(() => this.renderChart_r3_1());
      this.$nextTick(() => this.renderChart_r3_2());
      this.$nextTick(() => this.renderChart_r4_1());
      this.$nextTick(() => this.renderChart_r4_2());
    },
    async getAllData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (bmeConfig.isNewCarbon) {
        await this.getEnum();
      }
      await this.getData1();
      await this.getData2();
      await this.getData3();
      await this.getData4();
      await this.getData5();
      this.renderAllChart();
      this.timer = setTimeout(() => {
        this.getAllData();
      }, 30000);
    },
    async getEnum() {
      // 获取 processId的枚举值
      const findEnum = CONFIG.requestName + this.$apiOpt.enum;
      let res = await this.$apiUtils.get(findEnum, {
        customerId: this.customerId,
      });
      if (res) {
        this.processIdList = res;
      }
    },
    async getData1() {
      const findCarbonPollution =
        CONFIG.requestName + this.$apiOpt.findCarbonPollution;
      let res = await this.$apiUtils.get(findCarbonPollution, {
        customerId: this.customerId,
      });
      if (res) {
        this.carbonPollutionSum = res;
      }
    },
    async getData2() {
      this.benchmarking = [{}, {}, {}, {}, {}];
      const findIndustry = CONFIG.requestName + this.$apiOpt.findIndustry;
      let res = null;
      let xhrList = [];
      if (this.isSpecial && bmeConfig.isNewCarbon) {
        let p1 = this.$apiUtils.get(findIndustry, {
          customerId: this.customerId,
          paramName: "全厂",
        });
        xhrList.push(p1)
        this.processIdList.forEach((item) => {
          let p = this.$apiUtils.get(findIndustry, {
            customerId: this.customerId,
            paramName: item.processName,
          });
          xhrList.push(p);
        });
        res = await Promise.all(xhrList);
      } else {
        let p1 = this.$apiUtils.get(findIndustry, {
          customerId: this.customerId,
          paramName: "全厂",
        });
        let p2 = this.$apiUtils.get(findIndustry, {
          customerId: this.customerId,
          paramName: "烧结",
        });
        let p3 = this.$apiUtils.get(findIndustry, {
          customerId: this.customerId,
          paramName: "炼铁",
        });
        let p4 = this.$apiUtils.get(findIndustry, {
          customerId: this.customerId,
          paramName: "炼钢",
        });
        let p5 = this.$apiUtils.get(findIndustry, {
          customerId: this.customerId,
          paramName: "焦化",
        });
        res = await Promise.all([p1, p2, p3, p4, p5]);
      }
      if (res && res.length) {
        for (let i = 0; i < res.length; i++) {
          if (res[i]) {
            this.benchmarking[i] = {
              key: Object.keys(res[i]),
              value: Object.values(res[i]),
            };
          }
        }
      }
    },
    async getData3() {
      const findPollutionChange =
        CONFIG.requestName + this.$apiOpt.findPollutionChange;
      let res = await this.$apiUtils.get(findPollutionChange, {
        customerId: this.customerId,
      });
      if (res) {
        let objectData = { key: [], value: [] };
        res.forEach((item) => {
          item.time = item.time ? item.time.split("-")[1] + "月" : "";
          objectData.key.push(item.time);
          objectData.value.push(item.value);
        });
        this.allYearChangeData = objectData;
      }
    },
    async getData4() {
      const findPollutionChangeWeight =
        CONFIG.requestName + this.$apiOpt.findPollutionChangeWeight;
      let res = null;
      let xhrList = [];
      if (this.isSpecial && bmeConfig.isNewCarbon) {
        this.processIdList.forEach((item) => {
          let p = this.$apiUtils.get(findPollutionChangeWeight, {
            customerId: this.customerId,
            processId: item.processId,
          });
          xhrList.push(p);
        });
        res = await Promise.all(xhrList);
      } else {
        let p1 = this.$apiUtils.get(findPollutionChangeWeight, {
          customerId: this.customerId,
          // processId: 1,
          processId: bmeConfig.isNewCarbon
            ? this.processIdList.find((item) => item.processName === "烧结")[
                "processId"
              ]
            : 1,
        });
        let p2 = this.$apiUtils.get(findPollutionChangeWeight, {
          customerId: this.customerId,
          // processId: 2,
          processId: bmeConfig.isNewCarbon
            ? this.processIdList.find((item) => item.processName === "炼铁")[
                "processId"
              ]
            : 2,
        });
        let p3 = this.$apiUtils.get(findPollutionChangeWeight, {
          customerId: this.customerId,
          // processId: 3,
          processId: bmeConfig.isNewCarbon
            ? this.processIdList.find((item) => item.processName === "炼钢")[
                "processId"
              ]
            : 3,
        });

        let p4 = this.$apiUtils.get(findPollutionChangeWeight, {
          customerId: this.customerId,
          // processId: 3,
          processId: bmeConfig.isNewCarbon
            ? this.processIdList.find((item) => item.processName === "焦化")
              ? this.processIdList.find((item) => item.processName === "焦化")[
                  "processId"
                ]
              : ""
            : 4,
        });
        res = await Promise.all([p1, p2, p3, p4]);
      }
      if (res) {
        if (res && res.length) {
          for (let i = 0; i < res.length; i++) {
            if (res[i]) {
              let aData = { key: [], value: [] };
              res[i].forEach((item) => {
                aData.key.push(item.time && item.time.split("-")[1] + "月"),
                  aData.value.push(item.value);
              });
              this.processChangeData[i] = aData;
            }
          }
        }
      }
    },
    async getData5() {
      const findPollutionChangeBranchFactory =
        CONFIG.requestName + this.$apiOpt.findPollutionChangeBranchFactory;
      let xhrList = [];
      let res = null;
      if (this.isSpecial && bmeConfig.isNewCarbon) {
        this.processIdList.forEach((item) => {
          let p = this.$apiUtils.get(findPollutionChangeBranchFactory, {
            customerId: this.customerId,
            processId: item.processId,
          });
          xhrList.push(p);
        });
        res = await Promise.all(xhrList);
      } else {
        let p1 = this.$apiUtils.get(findPollutionChangeBranchFactory, {
          customerId: this.customerId,
          // processId: 1,
          processId: bmeConfig.isNewCarbon
            ? this.processIdList.find((item) => item.processName === "烧结")[
                "processId"
              ]
            : 1,
        });
        let p2 = this.$apiUtils.get(findPollutionChangeBranchFactory, {
          customerId: this.customerId,
          // processId: 2,
          processId: bmeConfig.isNewCarbon
            ? this.processIdList.find((item) => item.processName === "炼铁")[
                "processId"
              ]
            : 2,
        });
        let p3 = this.$apiUtils.get(findPollutionChangeBranchFactory, {
          customerId: this.customerId,
          // processId: 3,
          processId: bmeConfig.isNewCarbon
            ? this.processIdList.find((item) => item.processName === "炼钢")[
                "processId"
              ]
            : 3,
        });
        let p4 = this.$apiUtils.get(findPollutionChangeBranchFactory, {
          customerId: this.customerId,
          // processId: 3,
          processId: bmeConfig.isNewCarbon
            ? this.processIdList.find((item) => item.processName === "焦化")[
                "processId"
              ]
            : 3,
        });
        res = await Promise.all([p1, p2, p3, p4]);
      }

      if (res) {
        this.carbonPollutionProcess = res;
      }
    },
    renderChart_l1() {
      if (!this.chart_l1) {
        this.chart_l1 = echarts.init(this.$refs.chart_l1);
      } else {
        this.chart_l1.dispose();
        this.chart_l1 = null;
        this.chart_l1 = echarts.init(this.$refs.chart_l1);
      }
      unwarp(this.chart_l1).setOption(
        getOpt1(this.benchmarking[0], this.carbonPollutionSum, this.is89)
      );
    },
    renderChart_l2() {
      if (!this.chart_l2) {
        this.chart_l2 = echarts.init(this.$refs.chart_l2);
      } else {
        this.chart_l2.dispose();
        this.chart_l2 = null;
        this.chart_l2 = echarts.init(this.$refs.chart_l2);
      }
      unwarp(this.chart_l2).setOption(getOpt2(this.allYearChangeData));
    },
    renderChart_r1_1() {
      if (!this.chart_r1_1) {
        this.chart_r1_1 = echarts.init(this.$refs.chart_r1_1);
      } else {
        this.chart_r1_1.dispose();
        this.chart_r1_1 = null;
        this.chart_r1_1 = echarts.init(this.$refs.chart_r1_1);
      }
      unwarp(this.chart_r1_1).setOption(
        getOpt1(this.benchmarking[1], this.carbonPollutionProcess[0], this.is89)
      );
    },
    renderChart_r1_2() {
      if (!this.chart_r1_2) {
        this.chart_r1_2 = echarts.init(this.$refs.chart_r1_2);
      } else {
        this.chart_r1_2.dispose();
        this.chart_r1_2 = null;
        this.chart_r1_2 = echarts.init(this.$refs.chart_r1_2);
      }
      unwarp(this.chart_r1_2).setOption(
        getOpt2(this.processChangeData[0], this.chart_r1_2Per)
      );
    },
    renderChart_r2_1() {
      if (!this.chart_r2_1) {
        this.chart_r2_1 = echarts.init(this.$refs.chart_r2_1);
      } else {
        this.chart_r2_1.dispose();
        this.chart_r2_1 = null;
        this.chart_r2_1 = echarts.init(this.$refs.chart_r2_1);
      }
      unwarp(this.chart_r2_1).setOption(
        getOpt1(this.benchmarking[2], this.carbonPollutionProcess[1], this.is89)
      );
    },
    renderChart_r2_2() {
      if (!this.chart_r2_2) {
        this.chart_r2_2 = echarts.init(this.$refs.chart_r2_2);
      } else {
        this.chart_r2_2.dispose();
        this.chart_r2_2 = null;
        this.chart_r2_2 = echarts.init(this.$refs.chart_r2_2);
      }
      unwarp(this.chart_r2_2).setOption(
        getOpt2(this.processChangeData[1], this.chart_r2_2Per)
      );
    },
    renderChart_r3_1() {
      if (!this.chart_r3_1) {
        this.chart_r3_1 = echarts.init(this.$refs.chart_r3_1);
      } else {
        this.chart_r3_1.dispose();
        this.chart_r3_1 = null;
        this.chart_r3_1 = echarts.init(this.$refs.chart_r3_1);
      }
      unwarp(this.chart_r3_1).setOption(
        getOpt1(this.benchmarking[3], this.carbonPollutionProcess[2], this.is89)
      );
    },
    renderChart_r3_2() {
      if (!this.chart_r3_2) {
        this.chart_r3_2 = echarts.init(this.$refs.chart_r3_2);
      } else {
        this.chart_r3_2.dispose();
        this.chart_r3_2 = null;
        this.chart_r3_2 = echarts.init(this.$refs.chart_r3_2);
      }
      unwarp(this.chart_r3_2).setOption(getOpt2(this.processChangeData[2]));
    },
    renderChart_r4_1() {
      if (!this.chart_r4_1) {
        this.chart_r4_1 = echarts.init(this.$refs.chart_r4_1);
      } else {
        this.chart_r4_1.dispose();
        this.chart_r4_1 = null;
        this.chart_r4_1 = echarts.init(this.$refs.chart_r4_1);
      }
      unwarp(this.chart_r4_1).setOption(
        getOpt1(this.benchmarking[4], this.carbonPollutionProcess[3], this.is89)
      );
    },
    renderChart_r4_2() {
      if (!this.chart_r4_2) {
        this.chart_r4_2 = echarts.init(this.$refs.chart_r4_2);
      } else {
        this.chart_r4_2.dispose();
        this.chart_r4_2 = null;
        this.chart_r4_2 = echarts.init(this.$refs.chart_r4_2);
      }
      unwarp(this.chart_r4_2).setOption(getOpt2(this.processChangeData[3]));
    },
  },
};
</script>
<style lang="scss" scoped>
.co2Detail {
  width: 150%;
  .yellowLine {
    width: 350px;
    height: 3px;
    background: #ffad25;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    border-radius: 2px 2px 0px 0px;
    margin: 0 auto;
  }
  ._innerBox {
    padding: 30px 50px;
    display: flex;
    justify-content: space-around;
    height: calc(100% - 70px);
    overflow: scroll;
    .left_part {
      width: 34%;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      .l_title {
        height: 15%;
        width: 100%;
        display: flex;
        // justify-content: space-around;
        align-items: center;
        .leftBox-main {
          font-weight: 600;
        }
      }
      .l_container {
        height: 85%;
        width: 100%;
        .l_chart {
          height: 50%;
          display: flex;
          justify-content: space-around;
          .l_chart_name {
            width: 15%;
            height: 100%;
            writing-mode: vertical-lr;
            font-size: 26px;
            color: #f5a623;
            text-align: center;
            /* align-items: center; */
            line-height: 180px;
          }
          .l_chart_box {
            // width: 85%;
            width: 769px;
            height: 100%;
          }
        }
      }
    }
    .right_part {
      width: 66%;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      .r_part {
        height: 33%;
        display: flex;
        .r_part_name {
          width: 400px;
          height: 80px;
          line-height: 80px;
          font-size: 24px;
          margin-top: 80px;
        }
        .r_chart_box {
          width: calc(50% - 200px);
          height: 100%;
          :deep(canvas) {
            position: absolute;
            left: 23px !important;
          }
        }
        .r_chart_box_one {
          width: calc(50% - 200px);
          height: 100%;
          :deep(canvas) {
            width: 605px !important;
          }
        }
      }
    }
  }
}
.leftBox-main,
.r_part_name {
  width: 626px;
  height: 100px;
  background: linear-gradient(
    270deg,
    rgba(108, 151, 255, 0) 0%,
    rgba(58, 116, 255, 0.1) 100%
  );
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
  border: 1px solid;
  margin-bottom: 20px;
  border-image: linear-gradient(to left, #ffffff00, #a9c8fb) 1 10;
  margin-top: 25px;
  font-size: 26px;
  color: #f5a623;
  line-height: 100px;
  padding: 0 30px;
  span {
    margin: 0 11px 0 33px;
    font-size: 48px;
    font-weight: bold;
    color: #4be0ff;
    line-height: 48px;
  }
}
</style>
